<script setup>
import card_header from '@/components/card_header.vue';
import { get_terms } from '@/services/term';
import { get_faqs } from '@/services/faqs';
import { onMounted, ref } from 'vue';

const isOpen = ref(false)
onMounted(async()=>{
  await retrieve_faqs()
  await get_categories()
})

const faqs = ref([])
async function retrieve_faqs(){
  let response = await get_faqs()
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  faqs.value = response.result.data.data
}

const categories = ref([])
async function get_categories(){
  let response = await get_terms('faq_category', { exist: true, name: 'faq' })
  if(response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  categories.value = parseCatToFaq(response.result.data.term, response.result.data.term_relationship)
}

function parseCatToFaq(terms, term_relationship){
  terms = terms.data.map(item => {
    let tempTaxom = terms.included.find(taxom => taxom.attributes.term_id == item.id)
    let filteredFaq = term_relationship.data.filter(x => x.attributes.term_taxonomy_id == tempTaxom.id)
    let faqs_obj = []
    filteredFaq.map(i => {
      let faqObj = faqs.value.find(faq => faq.id == i.attributes.object_id)
      faqs_obj.push(faqObj)
    })
    return {
      ...item,
      faqs_obj
    }
  })
  return terms
}
</script>

<template>
  <div class="row" v-auto-animate>
    <div :class="[{'col-md-8 pe-2': isOpen}]">
      <div class="card">
        <card_header
          :title="'How can we help you?'" 
          :has_border="false"
          :narrow="false"
        />.
        <div class="card-body pt-0">
          <template v-if="categories.length == 0">
            <emptyCard />
          </template>
          <div v-else class="row">
            <div class="col-md-4 p-2"
              v-for="cat in categories"
            >
              <div 
                class="card shadow-none border mb-0"
              >
                <div class="card-body">
                  <h5>{{ cat.attributes.name }}</h5>
                  <template v-if="cat.faqs_obj.length == 0">
                    <emptyCard />
                  </template>
                  <ul v-else>
                    <li @click="isOpen = !isOpen" 
                      v-for="faq in cat.faqs_obj" 
                      class="text-primary"
                    >
                      {{ faq.attributes.title }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="isOpen" class="col-md-4 card">
      <card_header
        :title="'title 1'"
        :border="true"
        :is_narrow="true"
      />
      <div class="card-body">
        <p>Description</p>
      </div>
    </div>
  </div>
</template>